// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edui-default[data-v-7ba5bd90]  img {\n  max-width: 100%;\n}\n[data-v-7ba5bd90] .el-loading-parent--relative {\n  width: 100%;\n  height: 100%;\n}\n[data-v-7ba5bd90] .el-loading-mask {\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 10000;\n}", ""]);
// Exports
module.exports = exports;
